import { X, Download } from "lucide-react";

export default function VideoPlayerModal({ video, onClose }) {
  if (!video) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/80 backdrop-blur-md flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="video-modal"
    >
      <div
        className="relative w-full max-w-5xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3">
          <div className="text-sm text-zinc-400">{video.title || "Preview"}</div>
          <div className="flex items-center gap-2">
            <a
              href={video.url}
              download
              className="text-xs text-white border border-white/20 rounded-lg px-3 py-1.5 hover:bg-white/10 flex items-center gap-1.5"
              data-testid="video-modal-download"
            >
              <Download size={12} /> Download
            </a>
            <button
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-white/10"
              data-testid="video-modal-close"
            >
              <X size={16} />
            </button>
          </div>
        </div>
        <video
          src={video.url}
          controls
          autoPlay
          className="w-full rounded-xl bg-black"
        />
      </div>
    </div>
  );
}
